function TallyTemplate() {
    return (
      <div>
        {/* Placeholder to occupy space */}
        <div style={{ height: "2rem" }}></div>
  
        {/* Fixed Header */}
        <div
          style={{
            background: "linear-gradient(135deg, #f372b5, #8a8bf6)",
            height: "2rem",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "fixed",
            top: 0,
            left: 0,
            zIndex: 30000,
            gap: "0.5rem",
          }}
        >
          <a href="https://tally.ge/" target="_blank">
            <img src="https://www.tally.ge/images/logos/tally-logo-white.png" alt="tally logo" style={{
                height: '1.5rem'
            }} />
          </a>
          <h1 style={{ color: "#f9f9f9", fontSize: "14px", margin: 0 }}>
            ამ ვებსაიტის შესაკვეთად ეწვიეთ{" "}
            <a
              href="https://tally.ge/"
              target="_blank"
              style={{ color: "#ffffff", textDecoration: "underline" }}
            >
              Tally.ge-ს
            </a>
          </h1>
        </div>
      </div>
    );
  }
  
  export default TallyTemplate;
  